const ar = {
  nav: {
    identita: 'الهوية',
    prodotti: 'المنتجات',
    attivita: 'النشاط',
    servizi: 'الخدمات',
    contatti: 'اتصل بنا',
    openMenu: 'فتح القائمة',
    closeMenu: 'إغلاق القائمة',
  },
  hero: {
    title1: 'وُلدنا من الطبيعة',
    title2: 'لنبني عالماً',
    title3: 'مستداماً',
    cta: 'اكتشف المزيد',
    scroll: 'مرّر',
  },
  intro: {
    eyebrow: 'الهوية',
    title: 'نحن المادة والأرض والنمو والتاريخ',
    body:
      'شركة FIBER PLAST متخصصة في تصنيع الأنابيب والخزانات من الألياف الزجاجية والمواد الحرارية اللدنة المعزّزة، بفضل عمليات إنتاج متطوّرة معترف بها عالمياً. باستخدام تقنية Filament Winding الحصرية، تُصمّم FIBER PLAST وتُصنّع وتُوزّع منتجاتها المُخصَّصة حسب الطلب في أكثر من 30 دولة — لخدمة محطات الطاقة والصناعات الكيميائية والبتروكيميائية وقطاعات الطاقة والفضاء الجوي والصناعة البحرية.',
  },
  products: {
    eyebrow: 'المنتجات',
    title: 'قوة الألياف الزجاجية',
    subtitle: 'حلول مخصّصة من الألياف الزجاجية والمواد الحرارية اللدنة المعزّزة، مصنوعة بتقنية Filament Winding الخاصة بنا.',
    all: 'جميع المنتجات',
    discover: 'اكتشف المزيد',
    back: 'جميع المنتجات',
    others: 'منتجات أخرى',
    request: 'اطلب معلومات',
    features: [
      'تقنية Filament Winding الحصرية',
      'مواد من الألياف الزجاجية (GRP) وحرارية لدنة معزّزة',
      'مقاومة كيميائية وميكانيكية معتمدة',
      'إنتاج مخصص وفق رسومات العميل',
      'التوزيع في أكثر من 30 دولة حول العالم',
    ],
  },
  activity: {
    eyebrow: 'النشاط',
    title: 'مشاريع للمستقبل',
    body:
      'تُصمّم FIBER PLAST وتُصنّع الأنابيب والخزانات ومكوّنات متنوعة (مثل القنوات وأبراج التبريد والخلايا الكهربية) للاستخدامات المدنية والصناعية. نُوزّع منتجات مخصّصة في أكثر من 30 دولة وفق احتياجات العملاء.',
    sinceLabel: 'منذ 1978',
    sinceText: 'أكثر من 45 عاماً من الخبرة في المواد المركّبة، من قلب سردينيا إلى العالم.',
    cta: 'اكتشف المزيد',
    approachTitle: 'منهجنا',
    sectorsTitle: 'قطاعات التطبيق',
    intro:
      'تُصمّم FIBER PLAST وتُصنّع الأنابيب والخزانات والمكوّنات المختلفة — بما في ذلك القنوات وأبراج التبريد والخلايا الكهربية — للاستخدامات المدنية والصناعية. نعمل جنباً إلى جنب مع عملائنا من مرحلة التصميم حتى التشغيل في الموقع، مع ضمان الجودة والاستدامة وتحسين التكاليف في كل خطوة.',
    steps: [
      { t: 'تحليل الاحتياجات', d: 'دراسة تفصيلية للمتطلبات الفنية والتشغيلية.' },
      { t: 'التصميم الهندسي', d: 'حلول مخصّصة من الألياف الزجاجية والمواد الحرارية اللدنة المعزّزة.' },
      { t: 'إنتاج Filament Winding', d: 'التصنيع باستخدام تقنيتنا الحصرية المتطورة.' },
      { t: 'الاختبار والفحص', d: 'ضوابط الجودة وفق أعلى معايير الصناعة.' },
      { t: 'الشحن والتركيب', d: 'الخدمات اللوجستية والمساعدة الميدانية والدعم بعد البيع.' },
    ],
  },
  services: {
    eyebrow: 'الخدمات',
    title: 'الهندسة الخضراء',
    body:
      'تُقدّم FIBER PLAST المساعدة والتركيب في الموقع للمواد المُوَرَّدة. نُصمّم منتجاتنا الخاصة ونتولّى التغليف والشحن وفق متطلبات العميل، ضامنين الاستمرارية والجودة في جميع مراحل المشروع.',
  },
  identita: {
    eyebrow: 'الهوية',
    title: 'وُلدنا من الطبيعة لنبني عالماً مستداماً',
    blocks: [
      {
        title: 'نحن المادة',
        body:
          'المحرّك المادي لإنتاج FIBER PLAST هو الألياف الزجاجية، التي تنشأ من تحالف عنصرين موجودَين في الطبيعة: الألياف والراتنج. تعايش دائم يُلهم إنشاء الأعمال والبنى التحتية التي تُحيط بحياتنا اليومية: الأنابيب والخزانات وأبراج الغسل ومرشحات GRP والمكونات الحرارية اللدنة المعزّزة، إضافة إلى منتجات خاصة كالقنوات وأبراج التبريد والخلايا الكهربية.',
      },
      {
        title: 'نحن الأرض',
        body:
          'تكمن قوّة تاريخنا في الأرض التي وُلدنا فيها. قيمة مميزة تُعبّر عن هويتنا وخبرتنا. تأسست FIBER PLAST في قلب البحر المتوسط، في جزيرة سردينيا، حيث تتعايش الطبيعة والبيئة بانسجام مع نمو الشركات وتطوّرها.',
      },
      {
        title: 'نحن النمو',
        body:
          'تعمل الشركة منذ عام 1978، بدأت في السوق المحلية ثم توسّعت خارج الحدود. اليوم تسعى FIBER PLAST لتوسيع شبكتها كمقاول عام في الدول التي تعمل فيها، عبر خبرة عالية ومواد خام عالية الجودة تُميّز كل مشروع. سمة مميزة قادرة على توسيع علامة FIBER PLAST حول العالم.',
        quote:
          'وُلدنا في قلب البحر المتوسط، في جزيرة سردينيا، حيث تتعايش الطبيعة والبيئة بانسجام لتعزيز نمو الشركات وتطوّرها.',
      },
      {
        title: 'نحن التاريخ',
        body:
          'تتكوّن المواد المركّبة من مزيج من مادّتين أو أكثر (المصفوفة، الألياف، الإضافات). ينتج عن دمجها منتج خفيف الوزن ومقاوم ومتين، مع تطبيقات في قطاعات الفضاء والسيارات والرياضة والكهروتقنية والبناء.',
      },
    ],
  },
  contact: {
    eyebrow: 'اتصل بنا',
    title: 'لنتحدّث عن مشروعك',
    body:
      'هل تودّ الحصول على مزيد من المعلومات حول خدماتنا أو منتجاتنا؟ أو تريد تقديم ملاحظات أو لديك طلب خاص؟ املأ النموذج وسنعاود التواصل معك في أقرب وقت.',
    fields: { name: 'الاسم', surname: 'اسم العائلة', email: 'البريد الإلكتروني', message: 'الرسالة' },
    privacy: 'لقد قرأتُ ووافقتُ على',
    privacyLink: 'سياسة الخصوصية',
    submit: 'إرسال',
    submitting: 'جارٍ الإرسال…',
    okTitle: 'تم إرسال الرسالة',
    okBody: 'سنعاود التواصل معك في أقرب وقت.',
    errMissing: 'الرجاء ملء الاسم والبريد الإلكتروني والرسالة.',
    errMissingTitle: 'حقول ناقصة',
    errPrivacyTitle: 'سياسة الخصوصية',
    errPrivacy: 'يجب قبول سياسة الخصوصية لإرسال الرسالة.',
  },
  contatti: {
    legalOffice: 'المقر المسجَّل',
    opOffice: 'المقر التشغيلي',
    phone: 'الهاتف',
    fax: 'فاكس',
  },
  footer: {
    opOffice: 'المقر التشغيلي',
    nav: 'التصفح',
    tagline: 'صُنع في سردينيا · موزّع في أكثر من 30 دولة',
    rights: 'جميع الحقوق محفوظة.',
    privacy: 'سياسة الخصوصية وملفات تعريف الارتباط',
  },
  cta: {
    title: 'من الطبيعة، إلى صناعة الغد',
    body: 'مواد مركّبة خفيفة الوزن ومقاومة ومتينة لمحطات الطاقة والمنشآت الكيميائية والبحرية والفضائية في أكثر من 30 دولة.',
    button: 'تواصل معنا',
  },
  video: {
    eyebrow: 'فيديو',
    title: 'FIBER PLAST أثناء العمل',
    body: 'اكتشف تقنية Filament Winding الحصرية وعمليات الإنتاج التي تجعل مكوّنات FIBER PLAST فريدة — من التصميم إلى التسليم.',
    stat1: 'سنوات',
    stat2: 'دول',
    stat3: 'مم كحدّ أقصى',
  },
  stats: [
    { value: '45+', label: 'سنوات من الخبرة' },
    { value: '30+', label: 'دولة نخدمها' },
    { value: '5000', label: 'قطر أقصى بالمم' },
    { value: '1978', label: 'سنة التأسيس' },
  ],
  sectors: ['محطات الطاقة', 'الصناعة الكيميائية', 'البتروكيماويات', 'الطاقة', 'الفضاء الجوي', 'الصناعة البحرية'],
};

export default ar;
